import React from 'react';
import withData from '../../../../core/containers/withData';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';
import { buildStatsRow } from '../../../../utils';

class LastGamesAverageStats extends React.Component {
  renderRows() {
    const { data } = this.props;

    if (!data || !data.length) {
      return null;
    }

    let rows = [];

    data.map((row, i) => {
      buildStatsRow(row);

      return rows.push(
        <tr key={ i }>
          <td>
            { row.opponent ?
              <strong className="text-muted">Opp.</strong> :
              <strong>Team</strong>
            }
          </td>
          <td>{ row.points.toFixed(1) }</td>
          <td>{ row.q1_points.toFixed(1) }</td>
          <td>{ row.q2_points.toFixed(1) }</td>
          <td>{ row.q3_points.toFixed(1) }</td>
          <td>{ row.q4_points.toFixed(1) }</td>
          <td>{ row.fg_made.toFixed(1) }</td>
          <td>{ row.fg_attempts.toFixed(1) }</td>
          <td>{ row.fg_percent.toFixed(1) }</td>
          <td>{ row.p3_made.toFixed(1) }</td>
          <td>{ row.p3_attempts.toFixed(1) }</td>
          <td>{ row.p3_percent.toFixed(1) }</td>
          <td>{ row.p2_made.toFixed(1) }</td>
          <td>{ row.p2_attempts.toFixed(1) }</td>
          <td>{ row.p2_percent.toFixed(1) }</td>
          <td>{ row.ft_made.toFixed(1) }</td>
          <td>{ row.ft_attempts.toFixed(1) }</td>
          <td>{ row.ft_percent.toFixed(1) }</td>
          <td>{ row.of_rebounds.toFixed(1) }</td>
          <td>{ row.df_rebounds.toFixed(1) }</td>
          <td>{ row.assists.toFixed(1) }</td>
          <td>{ row.turnovers.toFixed(1) }</td>
          <td>{ row.steals.toFixed(1) }</td>
          <td>{ row.block_shots.toFixed(1) }</td>
          <td>{ row.shots_rejected.toFixed(1) }</td>
          <td>{ row.fouls_made.toFixed(1) }</td>
          <td>{ row.fouls_received.toFixed(1) }</td>
        </tr>
      );
    });

    return rows;
  }

  render() {
    const { last, combined, isFetching } = this.props;

    return (
      <Box title={ `Last ${last} Games Average Stats ${combined ? '(combined)': ''}` }
           className="table-responsive">
        { isFetching && <Spinner /> }
        <table className="table table-bordered table-hover table-stats">
        <tbody>
          <tr>
            <th></th>
            <th>PTS</th>
            <th>Q1</th>
            <th>Q2</th>
            <th>Q3</th>
            <th>Q4</th>
            <th>FG</th>
            <th>FGA</th>
            <th>FG%</th>
            <th>3P</th>
            <th>3PA</th>
            <th>3P%</th>
            <th>2P</th>
            <th>2PA</th>
            <th>2P%</th>
            <th>FT</th>
            <th>FTA</th>
            <th>FT%</th>
            <th>OR</th>
            <th>DR</th>
            <th>AS</th>
            <th>TO</th>
            <th>ST</th>
            <th>BS</th>
            <th>SR</th>
            <th>FM</th>
            <th>FR</th>
          </tr>
          { this.renderRows() }
        </tbody>
        </table>
      </Box>
    );
  }
};

export default withData(LastGamesAverageStats);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/LastGamesAverageStats/LastGamesAverageStats.js